import styled from 'styled-components';

export const SidebarContainer = styled.div<{ isCollapsed?: boolean }>`
  width: ${props => props.isCollapsed ? '0' : '300px'};
  height: calc(100vh - 60px); /* Soustraire la hauteur du header fixe par défaut */
  position: fixed;
  left: 0;
  top: 60px; /* Commence après le header fixe par défaut */
  background-color: #2c3e50;
  color: white;
  box-shadow: ${props => props.isCollapsed ? 'none' : '0 4px 12px rgba(0, 0, 0, 0.1)'};
  padding: ${props => props.isCollapsed ? '0' : '24px'};
  overflow-y: auto;
  z-index: 999; /* Un cran en dessous du header (z-index: 1000) */
  transition: width 0.3s ease, padding 0.3s ease, box-shadow 0.3s ease; /* Transitions optimisées */
  box-sizing: border-box;
  will-change: width, padding; /* Optimisation pour les animations */
  
  @media (max-width: 768px) {
    width: ${props => props.isCollapsed ? '0' : '100%'};
    height: calc(100vh - 56px); /* Header plus petit sur mobile */
    top: 56px;
    padding: ${props => props.isCollapsed ? '0' : '16px'};
    overscroll-behavior: contain; /* Éviter le débordement sur mobile */
  }
  
  @media (max-width: 480px) {
    height: calc(100vh - 52px); /* Header encore plus petit sur très petits écrans */
    top: 52px;
  }
`;

export const SidebarContent = styled.div<{ isCollapsed?: boolean }>`
  opacity: ${props => props.isCollapsed ? '0' : '1'};
  visibility: ${props => props.isCollapsed ? 'hidden' : 'visible'};
  transition: opacity 0.3s ease, visibility 0.3s ease;
  overflow: hidden;
`;

export const ToggleSidebarButton = styled.button<{ isCollapsed: boolean }>`
  position: fixed;
  left: ${props => props.isCollapsed ? '20px' : '310px'};
  top: 84px; /* Aligné parfaitement avec la croix de la searchbar */
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #2c3e50; /* Couleur de la sidebar */
  color: white;
  border: 2px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1001; /* Au-dessus du header (1000) et de la sidebar */
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  
  @media (max-width: 768px) {
    left: ${props => props.isCollapsed ? '20px' : '20px'};
    top: 80px; /* Aligné parfaitement avec la croix sur mobile */
  }
  
  @media (max-width: 480px) {
    top: 76px; /* Aligné parfaitement avec la croix sur très petits écrans */
  }
  
  &:hover {
    background-color: #34495e; /* Version plus claire de la couleur de la sidebar */
    transform: scale(1.05);
  }
  
  svg {
    font-size: 18px;
  }
  
  &:focus {
    outline: none;
  }
`;

export const MenuContainer = styled.div`
  margin-bottom: 16px;
  
  @media (max-width: 768px) {
    margin-bottom: 12px;
  }
`;

export const AddMenuButton = styled.button<{ $isVisible?: boolean }>`
  position: relative;
  left: 0;
  top: 0;
  background: ${props => props.$isVisible ? 'rgba(255, 255, 255, 0.15)' : 'rgba(255, 255, 255, 0.05)'};
  border: 1px solid ${props => props.$isVisible ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.1)'};
  border-radius: 4px;
  color: ${props => props.$isVisible ? 'rgba(255, 255, 255, 0.9)' : 'rgba(255, 255, 255, 0.5)'};
  cursor: ${props => props.$isVisible ? 'pointer' : 'not-allowed'};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  transition: all 0.2s ease;
  z-index: 10;
  margin-right: 8px;
  
  &:hover {
    background: ${props => props.$isVisible ? 'rgba(255, 255, 255, 0.25)' : 'rgba(255, 255, 255, 0.05)'};
    border-color: ${props => props.$isVisible ? 'rgba(255, 255, 255, 0.3)' : 'rgba(255, 255, 255, 0.1)'};
    transform: scale(1.1);
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  @media (max-width: 768px) {
    padding: 3px;
    margin-right: 6px;
    
    &:hover {
      transform: scale(1.05);
    }
  }
`;

export const AddButton = styled.button<{ $isVisible?: boolean }>`
  position: absolute;
  bottom: 20px;
  right: 20px;
  background: ${props => props.$isVisible ? 'rgba(255, 255, 255, 0.15)' : 'rgba(255, 255, 255, 0.05)'};
  border: 1px solid ${props => props.$isVisible ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.1)'};
  border-radius: 50%;
  color: ${props => props.$isVisible ? 'rgba(255, 255, 255, 0.9)' : 'rgba(255, 255, 255, 0.5)'};
  cursor: ${props => props.$isVisible ? 'pointer' : 'not-allowed'};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  transition: all 0.2s ease;
  z-index: 10;
  
  &:hover {
    background: ${props => props.$isVisible ? 'rgba(255, 255, 255, 0.25)' : 'rgba(255, 255, 255, 0.05)'};
    border-color: ${props => props.$isVisible ? 'rgba(255, 255, 255, 0.3)' : 'rgba(255, 255, 255, 0.1)'};
    transform: scale(1.1);
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  @media (max-width: 768px) {
    bottom: 15px;
    right: 15px;
    padding: 8px;
  }
`;

export const MenuItem = styled.div<{ $isExpanded: boolean }>`
  background-color: ${props => props.$isExpanded ? 'rgba(255, 255, 255, 0.1)' : 'rgba(255, 255, 255, 0.05)'};
  border-radius: 8px;
  margin-bottom: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  
  @media (max-width: 768px) {
    margin-bottom: 6px;
    border-radius: 6px;
  }
`;

export const MenuHeader = styled.button<{ $isExpanded: boolean }>`
  width: 100%;
  padding: 12px 16px;
  background: transparent;
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  
  &:active {
    background-color: rgba(255, 255, 255, 0.15);
    transform: scale(0.98);
  }
  
  @media (max-width: 768px) {
    padding: 10px 12px;
    font-size: 13px;
  }
  
  @media (max-width: 480px) {
    padding: 8px 10px;
    font-size: 12px;
  }
`;

export const MenuTitle = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  
  @media (max-width: 768px) {
    gap: 6px;
  }
`;

export const MenuIcon = styled.span<{ $isExpanded: boolean }>`
  transition: transform 0.3s ease;
  transform: rotate(${props => props.$isExpanded ? '180deg' : '0deg'});
  
  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

export const MenuContent = styled.div<{ $isExpanded: boolean }>`
  max-height: ${props => props.$isExpanded ? 'none' : '0'}; /* Pas de limite de hauteur quand développé */
  opacity: ${props => props.$isExpanded ? '1' : '0'};
  overflow: ${props => props.$isExpanded ? 'visible' : 'hidden'}; /* Permet le scroll quand développé */
  transition: all 0.3s ease;
  background-color: rgba(0, 0, 0, 0.1);
  
  @media (max-width: 768px) {
    transition: all 0.25s ease; /* Animation plus rapide sur mobile */
  }
`;

export const MenuInnerContent = styled.div`
  padding: 16px;
  
  @media (max-width: 768px) {
    padding: 12px;
  }
  
  @media (max-width: 480px) {
    padding: 8px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 0 5px;
  
  @media (max-width: 768px) {
    padding: 0 8px;
    margin-top: 10px; /* Réduire la marge supérieure pour aligner avec le bouton */
    margin-bottom: 15px;
    padding-left: 60px; /* Augmenter légèrement le padding à gauche pour éviter que le titre soit caché */
  }
`;

export const Title = styled.h1`
  font-size: 24px;
  color: white;
  margin: 0;
  font-weight: 600;
  
  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

export const CategoryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px; /* Réduit pour s'harmoniser avec les menus */
  width: 100%;
  box-sizing: border-box;
  overflow-y: auto; /* Permet le scroll vertical quand le contenu dépasse */
  overflow-x: hidden; /* Empêche le scroll horizontal */
  /* Pas de max-height pour permettre l'expansion complète */
  margin: 0; /* Supprimé pour s'intégrer dans les menus */
  
  /* Style personnalisé pour la scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 3px;
    
    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }
  }
  
  @media (max-width: 768px) {
    gap: 6px; /* Encore plus réduit sur mobile */
    
    &::-webkit-scrollbar {
      width: 4px;
    }
  }
`;

export const CategoryItem = styled.div<{ color: string; $isVisible?: boolean; $isDragging?: boolean }>`
  background-color: ${props => props.color || 'rgba(255, 255, 255, 0.08)'};
  border-radius: 6px; /* Plus arrondi pour s'harmoniser */
  margin-bottom: 0; /* Géré par CategoryList */
  transition: all 0.2s ease; /* Transition plus fluide */
  cursor: move;
  min-height: 44px; /* Légèrement plus petit */
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1); /* Bordure subtile */
  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  
  /* Effet visuel pour les catégories en cours de drag */
  ${props => props.$isDragging && `
    opacity: 0.7;
    transform: scale(0.98);
    filter: brightness(0.8);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
    border-color: rgba(255, 255, 255, 0.3);
  `}
  
  /* Effet visuel pour les catégories masquées */
  ${props => !props.$isDragging && props.$isVisible === false && `
    opacity: 0.4;
    filter: grayscale(70%) brightness(0.6);
    background-color: rgba(128, 128, 128, 0.2);
  `}

  &.droppable {
    transform: scale(1.02) !important;
    border: 2px dashed #4CAF50 !important;
    box-shadow: 0 0 16px rgba(76, 175, 80, 0.5) !important;
    background-color: rgba(76, 175, 80, 0.1) !important;
  }

  &:hover:not(.droppable) {
    transform: translateY(-1px);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
    border-color: rgba(255, 255, 255, 0.2);
    ${props => props.$isVisible === false && 'opacity: 0.6;'}
  }
  
  @media (max-width: 768px) {
    min-height: 40px;
    margin: 0;
    cursor: grab;
    border-radius: 5px;
    
    &:active:not(.droppable) {
      cursor: grabbing;
      transform: scale(1.01);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }
  }
`;

export const CategoryHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px; /* Plus compact pour s'harmoniser */
  height: 44px; /* Hauteur cohérente avec CategoryItem */
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  
  @media (max-width: 768px) {
    padding: 8px 12px;
    height: 40px;
  }
`;

export const CategoryName = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  
  .checkbox-container {
    display: flex;
    align-items: center;
  }
  
  input[type="checkbox"] {
    cursor: pointer;
  }
  
  span {
    font-weight: 500;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  flex-shrink: 0; /* Éviter que les boutons ne se rétrécissent */
  
  @media (max-width: 768px) {
    gap: 8px; /* Réduire légèrement l'espace entre les boutons sur mobile */
  }
`;

export const MarkerList = styled.div`
  padding: 0 14px 14px; /* Plus compact pour s'harmoniser */
  
  @media (max-width: 768px) {
    padding: 0 12px 12px;
  }
`;

export const MarkerItem = styled.div`
  background-color: rgba(0, 0, 0, 0.15); /* Plus sombre pour contraster */
  padding: 8px 12px; /* Plus compact */
  border-radius: 4px; /* Plus arrondi */
  margin-bottom: 6px; /* Espacement réduit */
  font-size: 13px; /* Légèrement plus petit */
  transition: all 0.2s ease;
  touch-action: pan-y;
  border: 1px solid rgba(255, 255, 255, 0.05); /* Bordure subtile */
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.25);
    border-color: rgba(255, 255, 255, 0.1);
    transform: translateX(2px); /* Animation subtile */
  }
  
  @media (max-width: 768px) {
    padding: 6px 10px;
    font-size: 12px;
    margin-bottom: 4px;
    
    &:active {
      background-color: rgba(0, 0, 0, 0.3);
      transform: scale(0.98);
    }
  }
`;

